
import React from "react";
import ServiceHeader from "../component/ServiceHeader";



const Service = () => {
    return (
        <div>
            <ServiceHeader />
        </div>
    );
}
//  maxWidth:'1332px',
export default Service;